import { ApiProperty } from '@nestjs/swagger';
import { IsNotEmpty, IsString, MaxLength } from 'class-validator';

export class RechazarOrdenPagoProveedorDto {
  @ApiProperty({ description: 'Motivo de rechazo de la orden de pago' })
  @IsString()
  @IsNotEmpty()
  @MaxLength(500)
  motivo: string;
}
